<template>
	<div>
		<div>
			<p class="titleColorSystem text-center">convocatorias</p>
		</div>
		<div class="sci-conv-content">
			<table class="sci-conv-table">
				<thead class="sci-conv-thead">
					<div class="sci-conv-busqueda">
						<input v-model="filtro" type="text" @keyup.enter="filtroConvocatorias" placeholder="Buscar Convocatorias" autofocus>
						<button @click="filtroConvocatorias" class="sci-conv-lupa"></button>
					</div>
					<span class="sci-conv-count">Hay {{ convCount }} convocatorias que coinciden con el filtro
						<br>
						<vue-excel-xlsx
							v-if="convocatorias.data.length > 0"
              class="sci-inf-excel"
              :data="convocatorias.data"
              :columns="columns"
              :filename="'Convocatorias'"
              :sheetname="'convocatorias'"
            >
              Descargar resultados
            </vue-excel-xlsx>
					</span>
					<tr class="text-center">
						<th class="sci-th-conv-nombre">nombre del proyecto</th>
						<th class="sci-th-conv-descripcion">descripcion</th>
						<div class="sci-conv-contVigencia">
							<span>vigencia</span>
							<div class="sci-conv-vigencia">
								<th>fecha inicio</th>
								<th>fecha cierre</th>
							</div>
						</div>
						<th class="sci-th-conv-pdf">Ver convocatoria</th>
					</tr>
				</thead>
				<tbody class="sci-conv-tbody">
					<tr class="sci-conv-tr2" v-for="convocatoria in filtroConvocatorias" :key="convocatoria.id">
						<td class="sci-conv-nombre">{{ convocatoria.nombre }}</td>
						<td class="sci-conv-descripcion">{{ convocatoria.descripcion ? convocatoria.descripcion : 'no tiene descripcion' }}</td>
						<div class="sci-conv-contVigencia2">
							<td class="sci-conv-fe_in">{{convocatoria.fecha_inicio ? convocatoria.fecha_inicio : 'no tiene fecha de inicio'}}</td>
							<td class="sci-conv-fe_fi">{{convocatoria.fecha_fin ? convocatoria.fecha_fin : 'no tiene fecha de finalización'}}</td>
						</div>
						<td class="sci-conv-pdf">
							<!-- <a :href="convocatoria.bases" v-if="convocatoria.bases !=null" download="filename" target="_blank">descarga</a> -->
							<a :href="convocatoria.bases" v-if="convocatoria.bases !=null" download="filename" target="_blank"><span class="material-icons">search</span></a>
						</td>
					</tr>
				</tbody>
			</table>
		</div>	
	</div>
</template>

<script>
import axios from 'axios'
export default {
	props: ["urlApi"],
    created(){
			this.traerConvocatorias();
    },
    data(){
        return{
					columns: [
						{label: "Nombre", field: "nombre"},
						{label: "Descripción", field: "descripcion"},
					],
					convocatorias: {
						data: []
					},
					filtro:''
        }
    },
    methods:{
			traerConvocatorias(){
					let urlConvocatorias = process.env.VUE_APP_API_URL + '/api/convocatorias';
					axios.get(urlConvocatorias)
						.then(responseConvocatorias => {this.convocatorias = responseConvocatorias.data})
			}
		},
		computed:{
			convCount: function(){
				return this.filtroConvocatorias.length;
			},
			filtroConvocatorias(){
				var convocatoriasFilter = this.convocatorias.data.filter((convocatoria) => (convocatoria.id +''+ convocatoria.nombre.toLowerCase()).includes(this.filtro.toLocaleLowerCase()));
				if(this.filtro){
					return convocatoriasFilter;
				}
				return this.convocatorias.data;
			}
		}
}
</script>

<style>
	.sci-conv-title{
		margin: 3% auto 0%;
		text-transform: uppercase;
		color: rgba(255,196,0,.9);
		font-weight: bold;
		font-size: 1.5em;
	}
	.sci-conv-dot{
		font-weight: bold;
		color: rgba(0,152,255,.9)
	}
	.sci-conv-dot:before{
		content:'';
		display: inline-block;
		width: 90px;
		height: 1px;
		background: rgba(0,0,0,0.5);
		margin-right: 1.2%;
		border-radius: 1px 1px;
	}
	.sci-conv-dot:after{
		content:'';
		display: inline-block;
		width: 90px;
		height: 1px;
		background: rgba(0,0,0,0.5);
		margin-left: 1.2%;
		border-radius: 0 0 0 0;
	}
	.sci-conv-content{
		margin-bottom: 3%;
	}
	.sci-conv-table{
		margin: 3% auto 0 auto;
		border-spacing: 0;
		width: 90%;
		transition: .5s ease-in-out;
		margin-bottom: 100px !important;
		 border-radius: 10px 10px 10px 10px ;
		-moz-border-radius: 10px 10px 10px 10px ;
		-webkit-border-radius: 10px 10px 10px 10px !important;
		/* border: 1px solid #aaa; */
	}
	.sci-conv-thead{
		background: transparent;
		color: #FFF;
		text-transform: uppercase;
		
	}
	.sci-conv-thead tr{
		display: grid;
		grid-template-columns: 1fr 1fr 2fr 2fr ;
		height: 65px;
		background-color: gainsboro;
		border-radius: 5px 5px 5px 5px;
		-moz-border-radius: 10px 10px 10px 10px;																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																														
		-webkit-border-radius: 5px 5px 5px 5px;
		color: #000;
	
	}
	.sci-conv-thead tr th{
		display: grid;
		align-self: center;
	}
	.sci-conv-busqueda{
		display: grid;
		justify-content: start;
		width: 100%;
		grid-template-columns: 1fr;
		position: relative;
	}
	.sci-conv-busqueda input{
		width: 40%;
		height: 30px;
		margin: 0rem 0 13px 0rem;
		/* border-radius: 0px 0 0 0px; */
		border: none;
		padding: 0 15px;
		font-size: .8em;
		position: relative;
		background: #aaa;
		color: #000;
		border-radius: 5px 5px 5px 5px;
		-moz-border-radius: 10px 10px 10px 10px;																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																														
		-webkit-border-radius: 5px 5px 5px 5px;
		
	}
	.sci-conv-busqueda input:focus{
		outline: 0;
	}
	.sci-conv-busqueda input::placeholder{
		text-transform: uppercase;
	}
	.sci-conv-lupa{
		background: #0084FF;
		border: none;
		width: 35px;
		height: 25px;
		position: relative;
		left: 36.5%;
		top: -57px;
		margin: 1rem 0 0 2rem;
		padding: 15px;border-radius: 10px 10px 10px 10px;
		-moz-border-radius: 10px 10px 10px 10px;
		-webkit-border-radius: 10px 10px 10px 10px;
	}
	.sci-conv-lupa:before{
		display: inline-block;
		content: '';
		width: 12px;
		height: 12px;
		border-radius: 50%;
		border: 2px solid #FFF;
		position: relative;
		left: -6px;
		top: -12px;
	}
	.sci-conv-lupa:after{
		content: '';
		width: 10px;
		height: 2px;
		display: inline-block;
		background: #FFF;
		transform: rotate(45deg);
		position: absolute;
		top: 18px;
		left: 19px;
	}
	.sci-inf-excel{
		font-weight: bold;
		color: rgb(117, 180, 239);
		font-size: 1.1rem;
		border: 1px solid #ccc;
		padding: .4rem;
		margin: 0rem 0 1rem 0;
		border-radius: 5px;
		display: grid;
	}
	.sci-conv-count{
		color: #0D47A1;
		font-size: 1.03rem;
		font-weight: bold;
		display: grid;
		text-align: left;
		padding: 0 0 2rem 0;
		grid-template-columns: 1fr 1fr;
	}
	.sci-conv-contVigencia{
		display: grid;
		min-width: 190px;
		grid-template-columns: 1fr;
	}
	.sci-conv-contVigencia span{
		display: grid;
		align-content: center;
	}
	.sci-conv-vigencia{
		min-width: 196px;
		display: grid;
		grid-template-columns: 1fr 1fr;
		font-size: .85rem;
	}
	.sci-conv-tbody{
		/* border: 1px solid #000; */
	}
	.sci-conv-tbody tr{
		display: grid;
		grid-template-columns: 1fr 1fr 2fr 2fr;
	}
	.sci-conv-tr2{
		display: grid;
		grid-template-columns: 1fr 1fr 2fr 2fr;
		/* border-bottom: 1px solid #000; */
	}
	.sci-conv-tr2 td {
		padding: 10px;
	}
	.sci-th-conv-nombre{
		width: 300px;
		min-width: 110px;
		text-align: center;
	}
	.sci-th-conv-descripcion{
		width: 500px;
		min-width: 150px;
		text-align: center;
	}
	.sci-conv-nombre{
		width: 300px;
		min-width: 110px;
		text-align: left;
	}
	.sci-conv-descripcion{
		width: 500px;
		min-width: 150px;
		/* border-left: 1px solid #aaa;
		border-right: 1px solid #02C; */
		text-align: left;
	}
	.sci-conv-pdf{
		/* border-left: 1px solid #02C; */
	}
	.sci-conv-fe_in{
		min-width: 70px;
		width: 180px;
	}
	.sci-conv-fe_fi{
		min-width: 95px;
		width: 180px;
	}

	@media only screen and (max-width: 1300px) and (min-width: 100px){
		.sci-conv-content{
			margin-bottom: 7%;
		}
		.sci-conv-table{
			margin: 5% auto 0 auto;
			border-spacing: 0;
			width: 80%;
			transition: .5s ease-in-out;
		}
		.sci-conv-thead{
			color: #FFF;
			text-transform: uppercase;
		}
		.sci-conv-thead tr{
			display: grid;
			grid-template-columns: 1fr 1fr 2fr 2fr ;
			height: 60px;
		}
		.sci-conv-thead tr th{
			display: grid;
			align-self: center;
		}
		.sci-conv-busqueda{
			display: grid;
			justify-content: start;
			width: 100%;
			grid-template-columns: 1fr;
		}
		.sci-conv-busqueda input{
			width: 35%;
			height: 30px;
			margin: 2rem 0 0 2rem;
			border-radius: 0px 0 0 0px;
			border: none;
			padding: 0 15px;
			font-size: .8em;
			position: relative;
			background: #FFF;
			color: #000;
		}
		.sci-conv-busqueda input:focus{
			outline: 0;
		}
		.sci-conv-busqueda input::placeholder{
			text-transform: uppercase;
		}
		.sci-conv-lupa{
			background: #0084FF;
			border: none;
			width: 35px;
			height: 25px;
			position: relative;
			left: 33%;
			top: -44px;
			margin: 1rem 0 0 2rem;
		}
		.sci-conv-lupa:before{
			display: inline-block;
			content: '';
			width: 12px;
			height: 12px;
			border-radius: 50%;
			border: 2px solid #FFF;
			position: relative;
			left: -3px;
		}
		.sci-conv-lupa:after{
			content: '';
			width: 10px;
			height: 2px;
			display: inline-block;
			background: #FFF;
			transform: rotate(45deg);
			position: absolute;
			top: 18px;
			left: 19px;
		}
		.sci-conv-tbody{
			/* border: 1px solid #000; */
		}
		.sci-conv-tbody tr{
			display: grid;
			grid-template-columns: 1fr 1fr 2fr 2fr;
		}
		.sci-conv-tr2{
			display: grid;
			grid-template-columns: 1fr 1fr 2fr 2fr;
			/* border-bottom: 1px solid #000; */
		}
		.sci-conv-tr2 td {
			padding: 10px;
		}
		.sci-th-conv-nombre{
			width: 250px;
			min-width: 110px;
			text-align: center;
		}
		.sci-th-conv-descripcion{
			width: 400px;
			min-width: 150px;
			text-align: center;
		}
		.sci-conv-nombre{
			width: 250px;
			min-width: 110px;
			text-align: left;
		}
		.sci-conv-descripcion{
			width: 400px;
			min-width: 150px;
			/* border-left: 1px solid #000; */
			text-align: left;
		}
		
		.sci-conv-contVigencia{
			display: grid;
			max-width: 222px;
			min-width: 190px;
			grid-template-columns: 1fr;
			background: #616161;
		}
		.sci-conv-contVigencia span{
			display: grid;
			align-content: center;
		}
		.sci-conv-vigencia{
			min-width: 196px;
			display: grid;
			grid-template-columns: 1fr 1fr;
		}
		.sci-th-conv-pdf{
			text-align: center;
		}
		.sci-conv-fe_in{
			min-width: 95px;
			width: 145px;
			font-size: .9em !important;

		}
		.sci-conv-fe_fi{
			min-width: 95px;
			width: 145px;
			font-size: .9em !important;

		}
	}		
	@media only screen and (max-width: 1000px) and (min-width: 50px){
		.sci-conv-table{
			margin: 5% auto 0 auto;
			border-spacing: 0;
			width: 80%;
			transition: .5s ease-in-out;
		}
		.sci-conv-thead{
			color: #FFF;
			text-transform: uppercase;
		}
		.sci-conv-thead tr{
			display: grid;
			grid-template-columns: 1fr 1fr 2fr 2fr ;
			height: 42px;
		}
		.sci-conv-busqueda{
			display: grid;
			justify-content: start;
			width: 100%;
			height: 70px;
			grid-template-columns: 1fr;
		}
		.sci-conv-busqueda input{
			width: 33%;
			height: 30px;
			margin: 2rem 0 0 2rem;
			border-radius: 0px 0 0 0px;
			border: none;
			padding: 0 15px;
			font-size: .8em;
			position: relative;
			background: #FFF;
			color: #000;
		}
		.sci-conv-busqueda input:focus{
			outline: 0;
		}
		.sci-conv-busqueda input::placeholder{
			text-transform: uppercase;
		}
		.sci-conv-lupa{
			background: #0084FF;
			border: none;
			width: 35px;
			height: 25px;
			position: relative;
			left: 30%;
			top: -44px;
			margin: 1rem 0 0 2rem;
		}
		.sci-conv-lupa:before{
			display: inline-block;
			content: '';
			width: 12px;
			height: 12px;
			border-radius: 50%;
			border: 2px solid #FFF;
			position: relative;
			left: -3px;
		}
		.sci-conv-lupa:after{
			content: '';
			width: 10px;
			height: 2px;
			display: inline-block;
			background: #FFF;
			transform: rotate(45deg);
			position: absolute;
			top: 18px;
			left: 19px;
		}
		.sci-conv-tbody{
			/* border: 1px solid #000; */
		}
		.sci-conv-tbody tr{
			display: grid;
			grid-template-columns: 1fr 1fr 2fr 2fr;
		}
		.sci-conv-tr2{
			display: grid;
			grid-template-columns: 1fr 1fr 2fr 2fr;
			/* border-bottom: 1px solid #000; */
		}
		.sci-conv-tr2 td {
			padding: 10px;
		}
		.sci-th-conv-nombre{
			width: 200px;
			min-width: 110px;
			text-align: center;
		}
		.sci-th-conv-descripcion{
			width: 350px;
			min-width: 150px;
			text-align: center;
		}
		.sci-conv-nombre{
			width: 200px;
			min-width: 110px;
			text-align: left;
		}
		.sci-conv-descripcion{
			width: 350px;
			min-width: 150px;
			/* border-left: 1px solid #000; */
			text-align: left;
		}
		
		.sci-conv-contVigencia{
			display: grid;
			max-width: 222px;
			min-width: 190px;
			grid-template-columns: 1fr;
		}
		.sci-conv-contVigencia span{
			display: grid;
			align-content: center;
		}
		.sci-conv-vigencia{
			min-width: 196px;
			display: grid;
			grid-template-columns: 1fr 1fr;
		}
		.sci-th-conv-pdf{
			text-align: center;
		}
		.sci-conv-fe_in{
			min-width: 95px;
			width: 145px;
			font-size: .9em !important;

		}
		.sci-conv-fe_fi{
			min-width: 95px;
			width: 145px;
			font-size: .9em !important;

		}
	}
	@media only screen and (max-width: 900px) and (min-width: 100px) {
		.sci-conv-table{
			margin: 5% auto 0 auto;
			border-spacing: 0;
			width: 80%;
			transition: .5s ease-in-out;
		}
		.sci-conv-thead{
			color: #FFF;
			text-transform: uppercase;
		}
		.sci-conv-thead tr{
			display: grid;
			grid-template-columns: 1fr 1fr 2fr 2fr ;
			height: 42px;
		}
		.sci-conv-busqueda{
			display: grid;
			justify-content: start;
			width: 100%;
			height: 65px;
			grid-template-columns: 1fr;
		}
		.sci-conv-busqueda input{
			width: 33%;
			height: 30px;
			margin: 2rem 0 0 2rem;
			border-radius: 0px 0 0 0px;
			border: none;
			padding: 0 15px;
			font-size: .8em;
			position: relative;
			background: #FFF;
			/* color: #000; */
		}
		.sci-conv-busqueda input:focus{
			outline: 0;
		}
		.sci-conv-busqueda input::placeholder{
			text-transform: uppercase;
		}
		.sci-conv-lupa{
			background: #0084FF;
			border: none;
			width: 35px;
			height: 25px;
			position: relative;
			left: 30%;
			top: -44px;
			margin: 1rem 0 0 2rem;
		}
		.sci-conv-lupa:before{
			display: inline-block;
			content: '';
			width: 12px;
			height: 12px;
			border-radius: 50%;
			border: 2px solid #FFF;
			position: relative;
			left: -3px;
		}
		.sci-conv-lupa:after{
			content: '';
			width: 10px;
			height: 2px;
			display: inline-block;
			background: #FFF;
			transform: rotate(45deg);
			position: absolute;
			top: 18px;
			left: 19px;
		}
		.sci-conv-tbody{
			/* border: 1px solid #000; */
		}
		.sci-conv-tbody tr{
			display: grid;
			grid-template-columns: 1fr 1fr 2fr 2fr;
		}
		.sci-conv-tr2{
			display: grid;
			grid-template-columns: 1fr 1fr 2fr 2fr;
			/* border-bottom: 1px solid #000; */
		}
		.sci-conv-tr2 td {
			padding: 10px;
		}
		.sci-th-conv-nombre{
			width: 150px;
			min-width: 110px;
			text-align: center;
		}
		.sci-th-conv-descripcion{
			width: 200px;
			min-width: 150px;
			text-align: center;
		}
		.sci-conv-nombre{
			width: 150px;
			min-width: 110px;
			text-align: left;
		}
		.sci-conv-descripcion{
			width: 200px;
			min-width: 150px;
			/* border-left: 1px solid #000; */
			text-align: left;
		}
		
		.sci-conv-contVigencia{
			display: grid;
			max-width: 222px;
			min-width: 190px;
			grid-template-columns: 1fr;
		}
		.sci-conv-contVigencia span{
			display: grid;
			align-content: center;
		}
		.sci-conv-vigencia{
			min-width: 196px;
			display: grid;
			grid-template-columns: 1fr 1fr;
		}
		.sci-th-conv-pdf{
			text-align: center;
		}
		.sci-conv-fe_in{
			min-width: 95px;
			width: 145px;
			font-size: .9em !important;

		}
		.sci-conv-fe_fi{
			width: 145px;
			font-size: .9em !important;

		}
	}
	@media only screen and (max-width: 720px) and (min-width: 50px){
		.sci-conv-table{
			margin: 5% auto 0 auto;
			border-spacing: 0;
			width: 80%;
			transition: .5s ease-in-out;
		}
		.sci-conv-thead{
			color: #FFF;
			text-transform: uppercase;
		}
		.sci-conv-thead tr{
			display: grid;
			grid-template-columns: 1fr 1fr 2fr 2fr ;
			height: 42px;
		}
		.sci-conv-busqueda{
			display: grid;
			justify-content: start;
			width: 100%;
			height: 65px;
			grid-template-columns: 1fr;
		}
		.sci-conv-busqueda input{
			width: 33%;
			height: 30px;
			margin: 1.5rem 0 0 2rem;
			border-radius: 0px 0 0 0px;
			border: none;
			padding: 0 15px;
			font-size: .8em;
			position: relative;
			background: #FFF;
			color: #000;
		}
		.sci-conv-busqueda input:focus{
			outline: 0;
		}
		.sci-conv-busqueda input::placeholder{
			text-transform: uppercase;
		}
		.sci-conv-lupa{
			background: #0084FF;
			border: none;
			width: 35px;
			height: 25px;
			position: relative;
			left: 30%;
			top: -44px;
			margin: 1rem 0 0 2rem;
		}
		.sci-conv-lupa:before{
			display: inline-block;
			content: '';
			width: 12px;
			height: 12px;
			border-radius: 50%;
			border: 2px solid #FFF;
			position: relative;
			left: -3px;
		}
		.sci-conv-lupa:after{
			content: '';
			width: 10px;
			height: 2px;
			display: inline-block;
			background: #FFF;
			transform: rotate(45deg);
			position: absolute;
			top: 18px;
			left: 19px;
		}
		.sci-conv-tbody{
			/* border: 1px solid #000; */
		}
		.sci-conv-tbody tr{
			display: grid;
			grid-template-columns: 1fr 1fr 2fr 2fr;
		}
		.sci-conv-tr2{
			display: grid;
			grid-template-columns: 1fr 1fr 2fr 2fr;
			/* border-bottom: 1px solid #000; */
		}
		.sci-conv-tr2 td {
			padding: 10px;
		}
		.sci-th-conv-nombre{
			width: 110px;
			min-width: 100px;
			text-align: center;
		}
		.sci-th-conv-descripcion{
			width: 160px;
			min-width: 140px;
			text-align: center;
		}
		.sci-conv-nombre{
			width: 110px;
			min-width: 100px;
			text-align: left;
		}
		.sci-conv-descripcion{
			width: 160px;
			min-width: 150px;
			/* border-left: 1px solid #000; */
			text-align: left;
		}
		
		.sci-conv-contVigencia{
			display: grid;
			max-width: 222px;
			min-width: 190px;
			grid-template-columns: 1fr;
		}
		.sci-conv-contVigencia span{
			display: grid;
			align-content: center;
		}
		.sci-conv-vigencia{
			min-width: 196px;
			display: grid;
			grid-template-columns: 1fr 1fr;
		}
		.sci-th-conv-pdf{
			text-align: center;
		}
		.sci-conv-fe_in{
			min-width: 95px;
			width: 145px;
			font-size: .9em !important;

		}
		.sci-conv-fe_fi{
			width: 145px;
			font-size: .9em !important;

		}
		.sci-conv-pdf{

		}
  	}
	@media only screen and (max-width: 600px) and (min-width: 50px){
		.sci-conv-table{
			margin: 5% auto 0 auto;
			border-spacing: 0;
			width: 80%;
			transition: .5s ease-in-out;
		}
		.sci-conv-thead{
			color: #FFF;
			text-transform: uppercase;
		}
		.sci-conv-thead tr{
			display: grid;
			grid-template-columns: 1fr 1fr 2fr 2fr ;
			height: 42px;
		}
		.sci-conv-busqueda{
			display: grid;
			justify-content: start;
			width: 100%;
			height: 65px;
			grid-template-columns: 1fr;
		}
		.sci-conv-busqueda input{
			width: 33%;
			height: 30px;
			margin: 1.5rem 0 0 2rem;
			border-radius: 0px 0 0 0px;
			border: none;
			padding: 0 15px;
			font-size: .7em;
			position: relative;
			background: #FFF;
			color: #000;
		}
		.sci-conv-busqueda input:focus{
			outline: 0;
		}
		.sci-conv-busqueda input::placeholder{
			text-transform: uppercase;
		}
		.sci-conv-lupa{
			background: #0084FF;
			border: none;
			width: 35px;
			height: 25px;
			position: relative;
			left: 30%;
			top: -44px;
			margin: 1rem 0 0 2rem;	
		}
		.sci-conv-lupa:before{
			display: inline-block;
			content: '';
			width: 12px;
			height: 12px;
			border-radius: 50%;
			border: 2px solid #FFF;
			position: relative;
			left: -3px;
		}
		.sci-conv-lupa:after{
			content: '';
			width: 10px;
			height: 2px;
			display: inline-block;
			background: #FFF;
			transform: rotate(45deg);
			position: absolute;
			top: 18px;
			left: 19px;
		}
		.sci-conv-tbody{
			/* border: 1px solid #000; */
		}
		.sci-conv-tbody tr{
			display: grid;
			grid-template-columns: 1fr 1fr 2fr 2fr;
		}
		.sci-conv-tr2{
			display: grid;
			grid-template-columns: 1fr 1fr 2fr 2fr;
			/* border-bottom: 1px solid #000; */
		}
		.sci-conv-tr2 td {
			padding: 10px;
		}
		.sci-th-conv-nombre{
			font-size: .8em !important;
			width: 80px;
			min-width: 50px;
			text-align: center;
		}
		.sci-th-conv-descripcion{
			font-size: 1em !important;
			width: 160px;
			min-width: 140px;
			text-align: center;
		}
		.sci-conv-nombre{
			font-size: .8em !important;
			width: 80px;
			min-width: 50px;
			text-align: left;
		}
		.sci-conv-descripcion{
			font-size: .9em !important;
			width: 160px;
			min-width: 150px;
			/* border-left: 1px solid #000; */
			text-align: left;
		}
		
		.sci-conv-contVigencia{
			font-size: .8em !important;
			display: grid;
			max-width: 222px;
			min-width: 190px;
			grid-template-columns: 1fr;
		}
		.sci-conv-contVigencia span{
			display: grid;
			align-content: center;
		}
		.sci-conv-vigencia{
			min-width: 196px;
			display: grid;
			grid-template-columns: 1fr 1fr;
		}
		.sci-th-conv-pdf{
			text-align: center;
		}
		.sci-conv-fe_in{
			min-width: 95px;
			width: 145px;
			font-size: .9em !important;

		}
		.sci-conv-fe_fi{
			width: 145px;
			font-size: .9em !important;

		}
	}
	@media only screen and (max-width: 530px) and (min-width: 50px){
		.sci-conv-table{
			margin: 5% auto 0 auto;
			border-spacing: 0;
			width: 80%;
			transition: .5s ease-in-out;
		}
		.sci-conv-thead{
			color: #FFF;
			text-transform: uppercase;
		}
		.sci-conv-thead tr{
			display: grid;
			grid-template-columns: 1fr 1fr 2fr 2fr ;
			height: 65px;
		}
		.sci-conv-busqueda{
			display: grid;
			justify-content: start;
			width: 100%;
			height: 60px;
			grid-template-columns: 1fr;
		}
		.sci-conv-busqueda input{
			width: 50%;
			height: 30px;
			margin: 2rem 0 0 1rem;
			border-radius: 0px 0 0 0px;
			border: none;
			padding: 0 15px;
			font-size: .6em;
			position: relative;
			background: #FFF;
			color: #000;
		}
		.sci-conv-busqueda input:focus{
			outline: 0;
		}
		.sci-conv-busqueda input::placeholder{
			text-transform: uppercase;
		}
		.sci-conv-lupa{
			background: #0084FF;
			border: none;
			width: 35px;
			height: 25px;
			position: relative;
			left: 40%;
			top: -44px;
			margin: 1rem 0 0 2rem;	
		}
		.sci-conv-lupa:before{
			display: inline-block;
			content: '';
			width: 12px;
			height: 12px;
			border-radius: 50%;
			border: 2px solid #FFF;
			position: relative;
			left: -3px;
		}
		.sci-conv-lupa:after{
			content: '';
			width: 10px;
			height: 2px;
			display: inline-block;
			background: #FFF;
			transform: rotate(45deg);
			position: absolute;
			top: 18px;
			left: 17px;
		}
		.sci-conv-tbody{
			/* border: 1px solid #000; */
		}
		.sci-conv-tbody tr{
			display: grid;
			grid-template-columns: 1fr 1fr 2fr 2fr;
		}
		.sci-conv-tr2{
			display: grid;
			grid-template-columns: 1fr 1fr 2fr 2fr;
			/* border-bottom: 1px solid #000; */
		}
		.sci-conv-tr2 td {
			padding: 10px;
		}
		.sci-th-conv-nombre{
			font-size: .8em !important;
			width: 110px;
			min-width: 100px;
			text-align: center;
		}
		.sci-th-conv-descripcion{
			font-size: .8em !important;
			width: 130px;
			min-width: 125px;
			text-align: center;
		}
		.sci-conv-nombre{
			font-size: 1em !important;
			width: 110px;
			min-width: 100px;
			text-align: left;
		}
		.sci-conv-descripcion{
			font-size: 1em !important;
			width: 130px;
			min-width: 125px;
			/* border-left: 1px solid #000; */
			text-align: left;
		}
		
		.sci-conv-contVigencia{
			font-size: .8em !important;
			display: grid;
			min-width: 130px;
			max-width: 130px;
			grid-template-columns: 1fr;
		}
		.sci-conv-contVigencia span{
			display: grid;
			align-content: center;
		}
		.sci-conv-vigencia{
			max-width: 130px;
			min-width: 130px;
			display: grid;
			grid-template-columns: 1fr 1fr;
		}
		.sci-th-conv-pdf{
			text-align: center;
			max-width: 60px;
			min-width: 60px;
		}
		.sci-conv-fe_in{
			max-width: 65px;
			min-width: 65px;
			font-size: .6em !important;

		}
		.sci-conv-fe_fi{
			width: 1px !important;
			max-width: 65px;
			min-width: 65px;
			font-size: .6em !important;

		}
		.sci-conv-pdf{
			max-width: 60px;
			min-width: 60px;
			font-size: .85em !important;

		}
	}
	@media only screen and (max-width: 400px) and (min-width: 50px){
		.sci-conv-table{
			margin: 5% auto 0 auto;
			border-spacing: 0;
			width: 80%;
			transition: .5s ease-in-out;
		}
		.sci-conv-thead{
			color: #FFF;
			text-transform: uppercase;
		}
		.sci-conv-thead tr{
			display: grid;
			grid-template-columns: 1fr 1fr 2fr 2fr ;
			height: 65px;
		}
		.sci-conv-busqueda{
			display: grid;
			justify-content: start;
			width: 100%;
			height: 60px;
			grid-template-columns: 1fr;
		}
		.sci-conv-busqueda input{
			width: 50%;
			height: 30px;
			margin: 1.3rem 0 0 1rem;
			border-radius: 0px 0 0 0px;
			border: none;
			padding: 0 15px;
			font-size: .6em;
			position: relative;
			background: #FFF;
			color: #000;
		}
		.sci-conv-busqueda input:focus{
			outline: 0;
		}
		.sci-conv-busqueda input::placeholder{
			text-transform: uppercase;
		}
		.sci-conv-lupa{
			background: #0084FF;
			border: none;
			width: 35px;
			height: 25px;
			position: relative;
			left: 40%;
			top: -44px;
			margin: 1rem 0 0 2rem;	
		}
		.sci-conv-lupa:before{
			display: inline-block;
			content: '';
			width: 12px;
			height: 12px;
			border-radius: 50%;
			border: 2px solid #FFF;
			position: relative;
			left: -3px;
		}
		.sci-conv-lupa:after{
			content: '';
			width: 10px;
			height: 2px;
			display: inline-block;
			background: #FFF;
			transform: rotate(45deg);
			position: absolute;
			top: 18px;
			left: 17px;
		}
		.sci-conv-tbody{
			/* border: 1px solid #000; */
		}
		.sci-conv-tbody tr{
			display: grid;
			grid-template-columns: 1fr 1fr 2fr 2fr;
		}
		.sci-conv-tr2{
			display: grid;
			grid-template-columns: 1fr 1fr 2fr 2fr;
			/* border-bottom: 1px solid #000; */
		}
		.sci-conv-tr2 td {
			padding: 10px;
		}
		.sci-th-conv-nombre{
			font-size: .8em !important;
			width: 73px;
			min-width: 40px;
			text-align: center;
		}
		.sci-th-conv-descripcion{
			font-size: .8em !important;
			width: 85px;
			min-width: 80px;
			text-align: center;
		}
		.sci-conv-nombre{
			font-size: .65em !important;
			width: 73px;
			min-width: 40px;
			text-align: left;
		}
		.sci-conv-descripcion{
			font-size: .7em !important;
			width: 85px;
			min-width: 80px;
			/* border-left: 1px solid #000; */
			text-align: left;
		}
		
		.sci-conv-contVigencia{
			font-size: .8em !important;
			display: grid;
			grid-template-columns: 1fr;
			max-width: 120px;
			min-width: 120px;
		}
		.sci-conv-contVigencia span{
			display: grid;
			align-content: center;
		}
		.sci-conv-vigencia{
			max-width: 120px;
			min-width: 120px;
			display: grid;
			grid-template-columns: 1fr 1fr;
		}
		.sci-th-conv-pdf{
			text-align: center;
			max-width: 60px;
			min-width: 60px;
		}
		.sci-conv-fe_in{
			max-width: 60px;
			min-width: 60px;
			font-size: .6em !important;

		}
		.sci-conv-fe_fi{
			width: 1px !important;
			max-width: 60px;
			min-width: 60px;
			font-size: .6em !important;

		}
		.sci-conv-pdf{
			max-width: 60px;
			min-width: 60px;
			font-size: .85em !important;

		}
	} 
	.text-center{
		text-align: center;
	}
</style>
